




































import Vue from 'vue'
import Component from "vue-class-component";

@Component
export default class CourseView extends Vue{
  detailedCourse: any[] = []

  constructor() {
    super();
    const courseId = this.$route.params.id
    if (courseId) {
      this.$axios.get('courses/' + courseId + '/course_list_detailed').then(req => {
        const data = req.data
        this.detailedCourse.push(data)
      })
    }
  }

  get currentCourse(): any {
    return this.detailedCourse[this.detailedCourse.length - 1]
  }

  localDateString(dateString: string): string {
    const date = new Date(dateString)
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const;
    return date.toLocaleDateString('de-DE', options)
  }

  deleteTutorial(id: string, index: string | number) {
    if(confirm(this.$t("course.confirm") + " " + id + "?")) {
      this.$axios.delete('tutorials/' + id).then(req => {
        alert(this.$t("course.alertSucceed"))
        this.currentCourse['tutorials'].splice(index, 1)
      }).catch(err => {
        alert(this.$t("course.alertFailed"))
      })
    }
  }

}
